import React, { useState, useEffect } from "react";
// import "../../../node_modules/react-progress-button/react-progress-button.css"
import { useSnackbar } from "react-simple-snackbar";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initialState } from "../../initialState";
import { getInvoice } from "../../actions/invoiceActions";
import { getAllItems } from "../../actions/itemActions";
import { toCommas } from "../../utils/utils";
import styles from "./InvoiceDetails.module.css";
import moment from "moment";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { Box } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import InputBase from "@material-ui/core/InputBase";
import { Container, Grid, Avatar } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Spinner from "../Spinner/Spinner";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ProgressButton from "react-progress-button";
import axios from "axios";
import { saveAs } from "file-saver";
import Modal from "../Payments/Modal";
import PaymentHistory from "./PaymentHistory";
import GetAppIcon from "@material-ui/icons/GetApp";
import {
  useMediaQuery,
  useTheme,
  createTheme,
  ThemeProvider,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

const InvoiceDetails = () => {
  const location = useLocation();
  const [state, setState] = useState(0);
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [commission, setCommission] = useState(0);
  const [Expense, setExpense] = useState(0);
  const [rates, setRates] = useState(0);
  const [vat, setVat] = useState(0);
  const [currency, setCurrency] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [client, setClient] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  const [type, setType] = React.useState("");
  const [status, setStatus] = useState("");
  const [company, setCompany] = useState({});
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { id } = useParams();
  //console.log("id", id);
  const { invoice } = useSelector((state) => state.invoices);
  //console.log(invoice);
  const items = useSelector((state) => state.items.items);
  const { profiles } = useSelector((state) => state.profiles);
  console.log("Profiles", profiles);
  const dispatch = useDispatch();
  const history = useHistory();
  const [sendStatus, setSendStatus] = useState(null);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [printStatus, setPrintStatus] = useState(null);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const user = JSON.parse(localStorage.getItem("profile"));

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    table: {
      minWidth: 650,
    },

    headerContainer: {
      // display: 'flex'

      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(1),
      backgroundColor: "red",
      borderRadius: "10px 10px 0px 0px",
    },
    wpContainer: {
      display: "flex",
      alignItems: "center",
    },
    whatsappIcon: {
      height: "3rem",
      width: "3rem",
      cursor: "pointer",
    },
    circularProgress: {
      marginLeft: "8px", // Add margin for mobile view
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    dispatch(getInvoice(id));
  }, [id, dispatch, location]);

  useEffect(() => {
    if (invoice) {
      //Automatically set the default invoice values as the ones in the invoice to be updated

      setExpense(invoice.expense);
      setCommission(invoice.commission);
      setInvoiceData(invoice);
      setRates(invoice.rates);
      setClient(invoice.client);
      setSupplier(invoice.supplier);
      setType(invoice.type);
      setStatus(invoice.status);
      setSelectedDate(invoice.dueDate);
      setVat(invoice.vat);
      setCurrency(invoice.currency);
      setSubTotal(invoice.subTotal);
      setTotal(invoice.total);
      setCompany(invoice?.businessDetails?.data);
      setSignatureDataUrl(invoice.signatureDataUrl);
    }
  }, [invoice]);
  useEffect(() => {
    dispatch(
      // getItemsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllItems()
    );
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    // dispatch(getProfilesByUser({ search: user?.result?._id }))
    dispatch(getProfile(user?.userProfile?._id));
  }, [location, dispatch]);
  //Get the total amount paid
  let totalAmountReceived = 0;
  for (var i = 0; i < invoice?.paymentRecords?.length; i++) {
    totalAmountReceived += Number(invoice?.paymentRecords[i]?.amountPaid);
  }

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };

  const createAndPrintPdf = () => {
    setPrintStatus("loading");
    axios
      .post(
        `${process.env.REACT_APP_API}/create-pdf/${invoice.invoiceNumber}`,
        {
          name: invoice.client.name,
          agentCode: invoice.client.agentCode,
          date: invoice.date,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: invoice.total,
          type: invoice.type,
          vat: invoice.vat,
          selling: invoice.selling,
          payable: invoice.payable,
          pax: invoice.pax,
          commission: invoice.commission,
          expense: invoice.expense,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
        }
      )
      .then(() =>
        axios.get(
          `${process.env.REACT_APP_API}/fetch-pdf/${invoice.invoiceNumber}`,
          {
            responseType: "blob",
          }
        )
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        setPrintStatus("success");

        // Open a new browser window for printing the PDF
        const printWindow = window.open(downloadUrl, "_blank");

        // Wait for the PDF to load, then trigger printing
        printWindow.onload = () => {
          printWindow.print();
          // You can close the print window automatically if needed
          // printWindow.close();
        };
      });
    // .then((res) => {
    //   const pdfBlob = new Blob([res.data], { type: "application/pdf" });
    //   // const downloadUrl = window.URL.createObjectURL(pdfBlob);
    //   // setDownloadStatus("success");
    //   // window.open(downloadUrl, "_blank");
    //   saveAs(pdfBlob, `order${invoice.invoiceNumber}.pdf`)
    //   const downloadUrl= `http://orders.sadhanaayurvedics.com/files/Exported-order/order${invoice.invoiceNumber}.pdf`
    //   window.open(downloadUrl,'_blank')
    //   setDownloadStatus("success");
    // });
  };
  const createAndDownloadPdf = () => {
    setDownloadStatus("loading");
    axios
      .post(
        `${process.env.REACT_APP_API}/create-pdf/${invoice.invoiceNumber}`,
        {
          name: invoice.client.name,
          agentCode: invoice.client.agentCode,
          date: invoice.date,
          id: invoice.invoiceNumber,
          notes: invoice.notes,
          subTotal: toCommas(invoice.subTotal),
          total: invoice.total,
          type: invoice.type,
          vat: invoice.vat,
          selling: invoice.selling,
          payable: invoice.payable,
          pax: invoice.pax,
          commission: invoice.commission,
          expense: invoice.expense,
          status: invoice.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(total - totalAmountReceived),
          company: company,
          invoiceData: invoiceData,
          profiles: profiles,
        }
      )
      .then(() =>
        axios.get(
          `${process.env.REACT_APP_API}/fetch-pdf/${invoice.invoiceNumber}`,
          {
            responseType: "blob",
          }
        )
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        // const downloadUrl = window.URL.createObjectURL(pdfBlob);
        // setDownloadStatus("success");
        // window.open(downloadUrl, "_blank");
        saveAs(pdfBlob, `order${invoice.invoiceNumber}.pdf`);
        const downloadUrl = `https://asn.mindtree.co.th/files/Exported-order/order${invoice.invoiceNumber}.pdf`;
        window.open(downloadUrl, "_blank");
        setDownloadStatus("success");
      });
  };
  // const downloadPdf = (fileName) => {
  //   const apiUrl = `${process.env.REACT_APP_API}/fetch-pdf/${fileName}`;
  //   axios
  //     .get(apiUrl, { responseType: "blob" })
  //     .then((response) => {
  //       const file = new Blob([response.data], { type: "application/pdf" });
  //       saveAs(file, fileName);
  //     })
  //     .catch((error) => {
  //       console.error("Error downloading PDF:", error);
  //     });
  // };

  //SEND PDF INVOICE VIA EMAIL
  const sendPdf = (e) => {
    e.preventDefault();
    setSendStatus("loading");
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API}/send-pdf-whatsapp`, {
        name: invoice.client.name,
        agentCode: invoice.client.agentCode,
        date: invoice.date,
        id: invoice.invoiceNumber,
        notes: invoice.notes,
        subTotal: toCommas(invoice.subTotal),
        total: invoice.total,
        type: invoice.type,
        vat: invoice.vat,
        selling: invoice.selling,
        payable: invoice.payable,
        pax: invoice.pax,
        commission: invoice.commission,
        expense: invoice.expense,
        status: invoice.status,
        totalAmountReceived: toCommas(totalAmountReceived),
        balanceDue: toCommas(total - totalAmountReceived),
        company: company,
      })
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        // //console.log(resres.data)
        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        setSendStatus("success");
        const encodedFilePath = encodeURIComponent(downloadUrl);
        //console.log("Client Phone Number", invoice.client.phone);
        const whatsappURL = `https://wa.me/${invoice.client.phone}?text=https://asn.mindtree.co.th/files/Exported-order/order${invoice.invoiceNumber}.pdf`;

        window.open(whatsappURL, "_blank");

        // window.open(res.data.whatsappURL, "_blank");
      })
      // .then(() => //console.log("invoice sent successfully"))
      .then(() => {
        setSendStatus("success");
        setLoading(false);
        history.push("/dashboard");
      })
      .catch((error) => {
        //console.log(error);
        setSendStatus("error");
      });
  };

  const iconSize = {
    height: "18px",
    width: "18px",
    marginRight: "10px",
    color: "gray",
  };
  const [open, setOpen] = useState(false);

  function checkStatus() {
    return totalAmountReceived >= total
      ? "green"
      : status === "Partial"
      ? "#1976d2"
      : status === "Paid"
      ? "green"
      : status === "Unpaid"
      ? "red"
      : "red";
  }

  if (!invoice) {
    return <Spinner />;
  }
  // const findItemNameById = (itemId) => {
  //   //console.log("parameter"+itemId);
  //   const item = items.find((item) => item._id ==itemId);
  //   //console.log(user)
  //   return item ? item.name : "";
  // };
  const colorTheme = createTheme({
    palette: {
      primary: {
        main: "#ef7f1a",
      },
    },
  });
  return (
    <div className={styles.PageLayout}>
      <div
        className={styles.buttons}
        style={{
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
          gap: "10px",
        }}
      >
        <div style={{ width: isSmallScreen ? "90%" : "auto" }}>
          {user?.result?.userType === "admin" && (
            <button
              className={styles.btn}
              onClick={() => editInvoice(invoiceData._id)}
            >
              <BorderColorIcon style={iconSize} />
              Edit Booking
            </button>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginRight: "10px",
          }}
        >
          <ProgressButton
            onClick={createAndDownloadPdf}
            state={downloadStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              backgroundColor: "Transparent",
              color: "#000000",
              border: "none",
              borderRadius: "24px",
              padding: "8px",
              height: "40px",
              width: isSmallScreen ? "100%" : "10rem",
              marginTop: "7px",
              cursor: "pointer",
            }}
          >
            Download
          </ProgressButton>
          {/* <ProgressButton
            onClick={createAndPrintPdf}
            state={printStatus}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              backgroundColor: "Transparent",
              color: "#000000",
              border: "none",
              borderRadius: "24px",
              padding: "8px",
              height: "40px",
              width: isSmallScreen ? "100%" : "10rem",
              marginTop: "7px",
              cursor: "pointer",
            }}
          >
            Print
          </ProgressButton> */}
          {/* <Button onClick={()=>IminPrint()}>
              IMIN Print
            </Button> */}
          {/* // if (clientData.phone.trim() === '') {
    //   newErrors.phone = 'Phone is required';
    //   isValid = false;
    // }else if(clientData.phone.length<10||clientData.phone.length>12){
    //   newErrors.phone = 'Please enter a valid phone number.';
    //   isValid = false;} */}

          {/* <ThemeProvider theme={colorTheme}>
            <div className={classes.wpContainer}>
              {loading ? (
                <CircularProgress
                  className={isSmallScreen ? classes.circularProgress : ""}
                />
              ) : (
                <img
                  className={classes.whatsappIcon}
                  src="https://www.sharethis.com/wp-content/uploads/2017/05/WhatsApp.png"
                  alt=""
                  onClick={sendPdf}
                />
              )}
            </div>
          </ThemeProvider> */}
        </div>
      </div>

      {invoice?.paymentRecords.length !== 0 && (
        <PaymentHistory paymentRecords={invoiceData?.paymentRecords} />
      )}

      <Modal open={open} setOpen={setOpen} invoice={invoice} />
      <div className={styles.invoiceLayout}>
        {/* Title Section */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#f25c41",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "white",
              textAlign: "center",
              fontWeight: "normal",
              lineHeight: 1,
              width: "100%",
            }}
          >
            CORAL ISLAND TOUR REPORT
          </Typography>
        </Box>

        <Container maxWidth="lg">
          {/* Top Section with Two Halves */}
          <Grid container spacing={3} sx={{ marginBottom: "28px" }}>
            {/* Left Half - Logo and Company Details */}
            <Grid item xs={12} md={6}>
              <Box sx={{ padding: "10px" }}>
                {/* Logo Container - Increased size */}
                <Box
                  sx={{
                    width: "100%",
                    height: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    "& img": {
                      // Target img directly in sx props
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      backgroundColor: "transparent",
                      maxWidth: "150px",
                      maxHeight: "150px",
                    },
                  }}
                >
                  <img src={profiles?.logo} alt="ASN Logo" />
                </Box>

                {/* Company Details - Centered */}
                <Box sx={{ textAlign: "center", marginBottom: "8px" }}>
                  <Typography
                    variant="h6" // Increased from h6 for better visibility
                    sx={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    {profiles?.businessName}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      marginBottom: "20px",
                      textAlign: "center",
                      fontSize: "1.1rem", // Slightly larger font
                    }}
                  >
                    {profiles?.contactAddress}
                  </Typography>
                </Box>

                {/* Pax Details - More structured layout */}
                <Grid container spacing={2}>
                  <TableContainer component={Paper}>
                    <Table
                      size="small"
                      aria-label="tour details table"
                      style={{ border: "1px solid #ddd" }}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd" ,fontSize:"16px"}}
                          >
                            <strong>Adult</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd",fontSize:"16px" }}>
                            {invoiceData?.adult || 0}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd" ,fontSize:"16px"}}
                          >
                            <strong>Child</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd" ,fontSize:"16px"}}>
                            {invoiceData?.child || 0}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd",fontSize:"16px" }}
                          >
                            <strong>Tour Leader</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd" ,fontSize:"16px"}}>
                            {invoiceData?.tourLeader || "-"}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            style={{ border: "1px solid #ddd",fontSize:"16px" }}
                          >
                            <strong>Guide</strong>
                          </TableCell>
                          <TableCell style={{ border: "1px solid #ddd" ,fontSize:"16px"}}>
                            {invoiceData?.guide || "-"}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Box>
            </Grid>
            {/* Right Half - Details with Borders */}
            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  border: "1px solid #ddd",
                  height: "100%",
                }}
                style={{ margin: "20px auto" }}
              >
                <Table style={{ borderCollapse: "collapse" }}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          width: "40%",
                          border: "1px solid #CCCCCC",
                          padding: "8px",
                         fontSize:"16px"
                        }}
                      >
                        <strong>Date</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoice
                          ? moment(invoice.date).format("DD-MM-YYYY")
                          : moment().format("DD-MM-YYYY")}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Bill Number</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.invoiceNumber}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Agent</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {client?.name}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Nationality</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.nationality}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Hotel</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.hotel}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Room Number</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.roomNumber}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Guest Code</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.guestCode}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#fff3e0",
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        <strong>Ref Num</strong>
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px solid #CCCCCC",
                          padding: "8px",fontSize:"16px"
                        }}
                      >
                        {invoiceData?.refNum}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </Grid>
          </Grid>

          {/* Tables Section */}
          <Grid container spacing={3}>
            {/* Activity Report Table */}
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        style={{
                          backgroundColor: "#f5f5f5",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "1.1rem",
                        }}
                      >
                        Activity Report
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>
                        Particulars
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"16px" }}>
                        Commission
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>Rate</TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"16px" }}>Unit</TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>Income</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceData?.selling?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ fontSize:"16px" }}>{item.itemName}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>
                          {item?.commission?.commissionValue}
                        </TableCell >
                        <TableCell style={{ fontSize:"16px" }}>{item.unitPrice}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>{item.quantity}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>{item.quantity * item.unitPrice}</TableCell>
                      </TableRow>
                    ))}
                    {/* Subtotal Row */}
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{ fontWeight: "bold", textAlign: "left",fontSize:"18px" }}
                      >
                        Sub Total
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"18px" }}>
                        {invoiceData?.selling?.reduce(
                          (total, item) =>
                            total + item.quantity * item.unitPrice,
                          0
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Tour Bill Table */}
            <Grid item xs={12} md={6}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        style={{
                          backgroundColor: "#f5f5f5",
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: "1.1rem",
                        }}
                      >
                        Tour Bill
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>
                        Particulars
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>Type</TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>
                        Commission
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>Rate</TableCell>
                      <TableCell style={{ fontWeight: "bold" ,fontSize:"16px"}}>Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceData?.payable?.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell >{item.itemName}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>{item.itemType}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>
                          {item?.commission?.commissionValue}
                        </TableCell>
                        <TableCell style={{ fontSize:"16px" }}>{item.unitPrice}</TableCell>
                        <TableCell style={{ fontSize:"16px" }}>{item.quantity * item.unitPrice}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{ fontWeight: "bold", textAlign: "left",fontSize:"18px" }}
                      >
                        Sub Total
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold",fontSize:"18px" }}>
                        {invoiceData?.payable?.reduce(
                          (total, item) =>
                            total + item.quantity * item.unitPrice,
                          0
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          {/* Summary Section */}
          <Box
            sx={{
              marginTop: "30px",
              borderTop: "1px solid rgba(0, 0, 0, 0.1)",
              paddingTop: "15px",
            }}
          >
            <Paper
              sx={{
                backgroundColor: "#ffeb3b",
                padding: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                  
                }}
              >
                {/* Left side - Commission */}
                <Typography variant="h5">
                  Commission: {currency} {toCommas(commission)}
                </Typography>

                {/* Right side - Expense */}
                <Typography
                  variant="h5"
                  sx={{
                    color: "red",
                  }}
                >
                  Total Expense: {currency} {toCommas(Expense)}
                </Typography>
              </Box>

              {/* Full width total payable/receivable */}
              <Box
                sx={{
                  width: "100%",
                  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                  paddingTop: "15px",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {commission > Expense
                    ? "Total Receivable:"
                    : "Total Payable:"}{" "}
                  {currency} {toCommas(commission - Expense)}
                </Typography>
              </Box>
            </Paper>
          </Box>

          {/* Footer */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px 0",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                width: "100%",
              }}
            >
              Thanks for Your Business
            </Typography>
          </Box>
        </Container>
      </div>
    </div>
  );
};

export default InvoiceDetails;
